import { m } from '@/lib/paraglide/messages'

// Câu cụ thể cho SHOP_FIELD_INVALID reason=invalid theo ô (params.field), vd
// "email", "slug", "items.2.link.phone", "ocop.certificate_image_url". Luật
// khớp server: usecase/shop (catalog_text.go, groups.go, home.go, home_types.go).
// ERP-06: không để người dùng chỉ thấy "Giá trị chưa hợp lệ.".

const PHONE_KEYS = new Set(['hotline', 'hotline2', 'phone', 'phones'])
const SLUG_KEYS = new Set(['slug', 'story_slug', 'categories'])
const URL_KEYS = new Set(['url', 'map_url', 'website', 'website_url'])
const IMAGE_KEYS = new Set(['image', 'images', 'image_mobile', 'logo'])

/** Ô cuối không phải chỉ số, vd "items.2.link.categories.0" → "categories". */
function lastKey(field: string): string {
    const parts = field.split('.').filter((p) => !/^\d+$/.test(p))
    return parts[parts.length - 1] ?? ''
}

export function shopInvalidFieldMessage(field: string, max: string): string {
    const key = lastKey(field)
    if (key === 'email') return m.error_shop_email_invalid()
    if (key === 'map_embed_url') return m.error_shop_map_embed_invalid()
    if (PHONE_KEYS.has(key)) return m.error_shop_phone_invalid()
    if (key === 'zalo') return m.error_shop_zalo_invalid()
    if (SLUG_KEYS.has(key))
        return m.error_shop_slug_invalid({ max: max || '80' })
    if (key === 'types') return m.error_shop_product_type_invalid()
    if (URL_KEYS.has(key)) return m.error_shop_url_invalid()
    if (
        IMAGE_KEYS.has(key) ||
        key.endsWith('image_url') ||
        key.endsWith('_image')
    )
        return m.error_shop_image_invalid()
    switch (key) {
        // Cài đặt website (usecase/shop/site_settings_types.go).
        case 'href':
            return m.siteSettings_error_href()
        case 'zalo_oa_id':
            return m.siteSettings_error_zalo_oa()
        case 'title_template':
            return m.siteSettings_error_title_template()
        case 'category_description_tpl':
        case 'product_description_tpl':
            return m.siteSettings_error_tpl_name({ token: '{name}' })
        case 'icon':
            return m.siteSettings_error_icon()
        case 'published_at':
            return m.cmsPost_error_published_future()
        case 'best_seller_rank':
            return m.error_shop_rank_invalid()
        case 'sort_order':
            return m.error_shop_sort_order_invalid()
        // Video hướng dẫn (usecase/shop/guide_videos.go).
        case 'duration_seconds':
            return m.error_shop_duration_invalid()
        case 'stars':
            return m.error_shop_ocop_stars_invalid()
        case 'year':
            return m.error_shop_ocop_year_invalid()
        // Cấp OCOP (nhóm sản phẩm lẫn khối OCOP trang chủ): national | provincial.
        case 'level':
            return m.error_shop_ocop_level_invalid()
        case 'valid_until':
            return m.error_shop_date_invalid()
        case 'related':
            return m.error_shop_related_invalid()
        case 'type':
            return m.error_shop_link_type_invalid()
        default:
            return m.error_shop_field_invalid()
    }
}
